import gql from 'graphql-tag';
import { uploadImage } from '../Plot/uploadImage';
import moment from 'moment';

export const updateEventMutation = gql`
  mutation updateEvent($id: ID!, $input: updateEventInput!) {
    updateEvent(id: $id, input: $input) {
      id
      name
      plot {
        id
        __typename
      }
      eventLocationId {
        id
        __typename
      }
      eventLocation {
        id
        __typename
      }
      customLocationDescription
      eventDirector {
        id
        __typename
      }
      evidenceCode1
      evidenceCode2
      evidenceCode3
      evidenceCode4
      evidenceCode5
      evidenceCode6
      evidenceCode7
      evidenceCode8
      evidenceCode9
      evidenceCode10
      evidenceUnlock1
      evidenceUnlock2
      evidenceUnlock3
      evidenceUnlock4
      evidenceUnlock5
      evidenceUnlock6
      evidenceUnlock7
      evidenceUnlock8
      evidenceUnlock9
      evidenceUnlock10
      numberOfEvidence
      bypassCode
      suspectsCode
      discountCode
      attendingActors
      eventCode
      eventCatId
      plotImage {
        url
        __typename
      }
      status
      dressCode
      eventDate {
        date
        time
        __typename
      }
      plotIntroduction
      createdAt
      updatedAt
      deletedAt
      __typename
    }
  }
`;

export const updateEvent = async ({ client, params }) => {

  // Check if plotImage already present
  if (params.data.plotImage.rawFile) {
    params.data.plotImage = await uploadImage(client, params, true);
  } else {
    params.data.plotImage = params.data.plotImage.url;
  }

  // Following parameters need to overwrite with the injected one
  params.data.eventLocationId = params.data.eventLocation.id;
  params.data.eventDirectorId = params.data.eventDirector.id;
  params.data.plotId = params.data.plot.id;
  params.data.eventDateISO = moment.utc(params.data.eventDateISO).format('YYYY-MM-DDTHH:mm')

  if (params.data.status == 'COMPLETED' && params.data.eventDateISO > moment().format('YYYY-MM-DDTHH:mm')) {
    throw new Error('Cannot complete event in the future.');
  }

  // params.data includes additional properties injected by RA which rejected by the service
  // that is the reason need to deconstruct and manually build the input
  const {
    id,
    name,
    plotId,
    eventDateISO,
    eventCode,
    evidenceCode1,
    evidenceCode2,
    evidenceCode3,
    evidenceCode4,
    evidenceCode5,
    evidenceCode6,
    evidenceCode7,
    evidenceCode8,
    evidenceCode9,
    evidenceCode10,
    evidenceUnlock1,
    evidenceUnlock2,
    evidenceUnlock3,
    evidenceUnlock4,
    evidenceUnlock5,
    evidenceUnlock6,
    evidenceUnlock7,
    evidenceUnlock8,
    evidenceUnlock9,
    evidenceUnlock10,
    numberOfEvidence,
    bypassCode,
    eventLocationId,
    customLocationDescription,
    eventDirectorId,
    suspectsCode,
    discountCode,
    attendingActors,
    plotImage,
    status,
    eventCatId,
    dressCode,
    plotIntroduction,
  } = params.data;

  const result = await client.mutate({
    mutation: updateEventMutation,
    variables: {
      id,
      input: {
        name,
        plotId,
        eventDateISO,
        eventCode,
        eventLocationId,
        customLocationDescription,
        eventDirectorId,
        evidenceCode1,
        evidenceCode2,
        evidenceCode3,
        evidenceCode4,
        evidenceCode5,
        evidenceCode6,
        evidenceCode7,
        evidenceCode8,
        evidenceCode9,
        evidenceCode10,
        evidenceUnlock1,
        evidenceUnlock2,
        evidenceUnlock3,
        evidenceUnlock4,
        evidenceUnlock5,
        evidenceUnlock6,
        evidenceUnlock7,
        evidenceUnlock8,
        evidenceUnlock9,
        evidenceUnlock10,
        numberOfEvidence,
        bypassCode,
        suspectsCode,
        discountCode,
        attendingActors,
        plotImage,
        status,
        dressCode,
        eventCatId,
        plotIntroduction,
      },
    },
  });

  return result.data;
};
